<template>
  <md-dialog
      class="md-dialog-information"
      :md-active.sync="showInformationDialog"
      :md-click-outside-to-close="true"
      :md-close-on-esc="true">
    <md-dialog-content>
      <div class="md-layout">
        <div class="md-layout-item" v-if="information">
          <p class="md-subheading">{{ information.information_date }}</p>
          <p class="md-title">{{ information.subject }}</p>
          <p class="md-body-1" v-html="information.body"></p>
        </div>
      </div>
    </md-dialog-content>
    <div class="md-layout md-gutter md-alignment-center-space-between">
      <div class="md-layout-item md-size-30 more">
        <router-link :to="{name: 'BackendUserNotifications'}">
          <span>その他お知らせ</span>
          <md-icon>arrow_right</md-icon>
        </router-link>
      </div>
      <div class="md-layout-item">
        <md-dialog-actions>
          <md-checkbox v-model="form.doNotShowAgain" value="on">次回から表示しない</md-checkbox>
          <md-button class="md-primary md-raised" @click="close">閉じる</md-button>
        </md-dialog-actions>
      </div>
    </div>
  </md-dialog>
</template>


<script>
import LoadingSpinnerOverlay                          from '../../../components/LoadingSpinnerOverlay';
import CommonMixin                                    from '../../../mixins/commonMixin';
import Common                                         from '../../../modules/common';
import {apiClientWithUserToken as apiClient, apiList} from '../../../modules/apiClient';
import {validationMixin}                              from 'vuelidate';

export default {
  name      : 'InformationDialog',
  components: {
    LoadingSpinnerOverlay,
  },
  mixins    : [validationMixin, CommonMixin],
  props     : {
    mapInit: {
      type   : Object,
      default: null,
    },
  },
  data() {
    return {
      showInformationDialog: false,
      information          : null,
      form                 : {
        doNotShowAgain: false,
      },
      Common               : Common,
    }
  },
  mounted() {
    this.initNotifications();
  },
  watch  : {
    showInformationDialog: function (newValue) {
      if (newValue !== false) {
        return;
      }
      if (this.form.doNotShowAgain !== 'on') {
        return;
      }

      // 「次回から表示しない」にチェックが入っている場合は、お知らせを既読として記録しておく
      apiClient.post(apiList.information.doNotShowAgain, {information_id: this.information.information_id})
          .then(response => {
          })
          .catch(error => {
            this.errorMessages = [error.message];
          });
    }
  },
  methods: {
    /**
     * 閉じるボタン
     */
    close() {
      this.showInformationDialog = false;
    },
    /**
     * お知らせ情報を参照
     */
    initNotifications() {
      if (!localStorage.getItem(Common.localStorageKeys.user.fromLogin)) {
        // ログイン画面以外から遷移した場合は処理しない
        return;
      }
      localStorage.removeItem(Common.localStorageKeys.user.fromLogin);


      this.notifications = [];
      apiClient.get(apiList.information.publication)
          .then(response => {
            if (this.hasResponseErrors(response)) {
              return;
            }
            if (response.data && response.data.length > 0) {
              this.information           = response.data[0];
              this.information.body      = this.information.body.replace(/\n/g, '<br/>');
              this.information.body      = Common.replaceUrlToLink(this.information.body);
              this.showInformationDialog = true;
            }
          })
          .catch(error => {
            this.errorMessages = [error.message];
          });
    },
  }
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/components.scss";

.md-dialog-information {
  display: flex;

  ::v-deep(.md-dialog-container) {
    min-width: 60%;
    max-width: 80%;
    max-height: 100%;
  }
}

.md-subheading {
  margin-bottom: 0;
}

.md-title {
  font-size: 24px;
  margin: 0;
}

.md-body-1 {
  margin-top: 30px;
  word-break: break-all;
}

.more {
  margin-left: 20px;
}
</style>
